import { User } from '../user/User';
import { MESSAGE_ACTIONS, MESSAGE_STATUS } from '../../enums/Enums';
import { ITEM_TYPES } from '../../item/item-types';
import { Message } from '../../messages/message';
import { MessageData } from './message-data';
import { LeitnerContent } from './leitner-content-interface';
import { MESSAGE_TYPES } from '../../item/message-types';
export abstract class AbstractChatMessage {
    public messageID: string;
    public chatID: string;
    public messageType: MESSAGE_TYPES;
    public from: User;
    get possibleStatuses(): MESSAGE_STATUS { return MESSAGE_STATUS; }
    public status: string;
    public statusHistory: Array<string> = [];
    public received: boolean;
    public receivedTime: string;
    public minimized: boolean;
    public timestamp: Date;
    public scheduled: boolean = false;
    public scheduledTime: Date = new Date("1979-01-01");;
    public content: any;
    public showOptionMenu: boolean = false;
    constructor() {
    }
    hasContent(): boolean {
        throw "abstract has content"
    }
    setContent(data: any) {
        this.content = data;
    }
    getContent() {
        return this.content
    }
    getContentString(): string {
        throw "abstract get message not work here"
    }
    setUser(user: User) {
        this.from = user;
    }
    getMessageData():MessageData<any> {
        let wrongValue = null;
        if (!this.messageID) wrongValue = "messageID"
        if (!this.messageType) wrongValue = "messageType"
        if (!this.timestamp) wrongValue = "timestamp"
        if (!this.content) wrongValue = "content"
        if(wrongValue){
            console.warn("wrong ",wrongValue)
            throw new Error("not valid because of "+wrongValue)
          }
        return {
            content: this.content,
            from: this.from?.userID || "",
            messageID: this.messageID,
            messageType: this.messageType,
            itemID: this.chatID,
            received: true,
            receivedTime: "",
            timestamp: new Date(this.timestamp),
            scheduledTime: new Date(this.scheduledTime)
        }
    }
    setMessageID(messageID: string) {
        this.messageID = messageID;
    }
    setShowOptionMenu(enable: boolean) {
        this.showOptionMenu = enable;

    }
    isFrom(user: User) {
        return this.from.userID == user.userID;
    }
    isShowOptionMenu() {
        return this.showOptionMenu;
    }
    isShowAvatar() {
        //        return this.received && this.from.email != this.
    }
    setMessageTimeSent(sentTime: string) {
        this.receivedTime = sentTime;
    }
    minmize() {
        this.minimized = true;
    }
    maximize() {
        this.minimized = false;
    }
    setType(messageType: MESSAGE_TYPES) {
        this.messageType = messageType;
    }
    getSimpleModel(): Message {
        return {
             content: JSON.stringify(this.content),
             messageType: this.messageType, 
             timeSent: new Date(this.timestamp),
             messageID: this.messageID,
             itemID: ""

        }
    }
    getModel(modelFilter: Array<string>) {
        let model = {};
        // for (let filter of modelFilter){
        //     model[filter] = this.[filter];
        // }
    }
    getModelTypeID() {
        return { "type": this.messageType, "messageID": this.messageID };
    }
    needContent() {
        return !this.hasContent() && !this.isChatMessage();
    }
    public isChatMessage() {
        return this.messageType == MESSAGE_TYPES.Chat;
    }
    isLeitnerMessage() {
        return this.messageType == MESSAGE_TYPES.Leitner;
    }
    isInteractiveChatJourney(){
        return this.messageType == MESSAGE_TYPES.InteractiveChatJourney;
    }
    isQuizMessage() {
        return this.messageType == MESSAGE_TYPES.Quiz;
    }
    isDictionaryMessage() {
        return this.messageType == MESSAGE_TYPES.Dictionary;
    }
    isAdsMessage() {
        return this.messageType == MESSAGE_TYPES.AdsMessage;
    }

    isQuiz() {
        return this.messageType === MESSAGE_TYPES.Quiz
    }
    isLesson() {
        return this.messageType === MESSAGE_TYPES.Lesson
    }

    // isDictionaryMessage() {
    //     return this.type === MESSAGE_TYPES.Dictionary
    // }
    isLocalType() {
        return this.messageType == MESSAGE_TYPES.Leitner
    }
    getReceivedInt() {
        if (this.received)
            return 1;
        else
            return 0;
    }
    getSummary() {
        // return this.content.slice(0,15);
    }
    setStatus(status: string) {
        this.status = status;
        this.addStatusHistory()
    }
    isStatus(status: string) {
        return this.status == status;
    }
    hasStatus(status: string) {
        return this.statusHistory.indexOf(status) != -1;
    }
    addStatusHistory() {
        this.statusHistory.push(this.status);
    }
    setReceivedTime(receivedTime: string) {
        this.receivedTime = receivedTime;
    }
    setReceivedFromInt(received: Number) {
        if (received == 0) {
            this.received = false;
        }
        else {
            this.received = true;
        }
    }
    setFoldingFromInt(folding: Number) {
        if (folding == 1) {
            this.minimized = true;
        }
        else {
            this.minimized = false;
        }
    }
    static getExistedStatuses(): MESSAGE_STATUS {
        return new MESSAGE_STATUS();
    }
    getFoldedInt() {
        if (this.minimized)
            return 1;
        else
            return 0;
    }
    hasBeenSeenByMe() {
        return this.statusHistory.indexOf(this.possibleStatuses.seenByMe) >= 0;
    }
    getAction() {
        let action;
        switch (this.messageType) {
            case "dictionary":
                action = "transl";
                break;
            case "puzzle":
                action = "getPuzzle";
                break;
            case "news":
                action = "getNews";
                break;
            case MESSAGE_TYPES.Chat:
                action = MESSAGE_ACTIONS.SendMsg;
                break;
        }
        return action;
    }
    public getData() {
        let data;
        switch (this.messageType) {
            case MESSAGE_TYPES.Dictionary:
                data = { 'word': this.content, 'lang': this.getLang(), 'type': this.messageType };
                break;
            case MESSAGE_TYPES.Chat:
                data = { 'word': this.content, 'type': this.messageType };
                break;
        }
        return data;
    }

    getLang() {
        if (this.isArabic()) {
            return "fa";
        }
        else {
            return "de";
        }
    }
    isArabic() {
        var arabic = /[\u0600-\u06FF]/;
        return arabic.test("this.content.title"); // displays true
    }
    isPersian() {
        return this.isArabic();
    }
    isGerman() {
        !this.isArabic();
    }
    isSent() {
        return this.status == this.possibleStatuses.receivedByServer;
    }
    isDelivered() {
        return this.status == this.possibleStatuses.deliveredToUser;
    }

}